window.test_section_show = true;

const test_viewport_width = '500px';
const testExperienceID = '49fae251-6dbc-48ee-84f7-8eac62e5b9cc';
const testVariationID = '3223dfe9-773c-4d96-a3b9-384fc0b6bb6a';

const existed_sections = [
  '.header__heading-logo'
];

const test_new_sections = [
  '.header__heading-logo.test_mobile_first_logo'
];

var hasUiSwing = false;

window.addEventListener('ig:ready', () => {
  const runningExperiments = window.igData?.user.getExperiments();
  if(runningExperiments.length > 0){
    runningExperiments.forEach((data)=>{
      if(data.id == testExperienceID){
        let runningVariationID = window.igData?.user.getTestGroup(data.id);
        console.log(runningVariationID.id, testVariationID);
        if(runningVariationID.id == testVariationID){
          localStorage.setItem('testUiSwing', true);
          testSectionsHandler();
          addEventListener("resize", (event) => {
            testSectionsHandler();
          });
        }else{
          localStorage.setItem('testUiSwing', false);
        }
      }else{
        if (localStorage.getItem('testUiSwing') == null || localStorage.getItem('testUiSwing') == '') {
          localStorage.setItem('testUiSwing', 'false2');
        }
      }
    })
  }

  if (localStorage.getItem('testUiSwing') == null || localStorage.getItem('testUiSwing') == '') {
    localStorage.setItem('testUiSwing', false);
  }

  hasUiSwing = localStorage.getItem('testUiSwing');

  if(hasUiSwing == 'true'){
    testSectionsHandler();
    addEventListener("DOMContentLoaded", (event) => {
      testSectionsHandler();
    })
    addEventListener("resize", (event) => {
      testSectionsHandler();
    });
  }
  
})


function testSectionsHandler(){
  if(window.matchMedia(`(max-width: ${test_viewport_width})`).matches && window.test_section_show == true){
    hideSection(existed_sections);
    showSection(test_new_sections);
  }else{
    showSection(existed_sections);
    hideSection(test_new_sections);
  }
}

function hideSection(selectors){
  selectors.forEach((selector)=>{
    document.querySelectorAll(`${selector}`).forEach((el)=>{
      el.style.display = 'none';
    })
  })
}

function showSection(selectors){
  selectors.forEach((selector)=>{
    document.querySelectorAll(`${selector}`).forEach((el)=>{
      el.style.display = 'block';
    })
  })
}